import { useState } from 'react';
import { SketchPicker } from 'react-color';

function InputPicker({ id, label, customColor, handleQrCustom }) {
  const [showPicker, setShowPicker] = useState(false);
  const handleShowPicker = () => setShowPicker(!showPicker);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          id={id}
          name={id}
          aria-label={id}
          type="button"
          style={{ background: customColor ,cursor:"pointer"}}
          onClick={handleShowPicker}
        />
        <label htmlFor={id}><strong>Personalizar {label}</strong></label>
      </div>
      {showPicker && (
        <SketchPicker
          presetColors={['#000000', '#FFFFFF']}
          color={customColor}
          onChange={handleQrCustom}
        />
      )}
    </div>
  );
}

export default InputPicker;
